import { plans, type PlanType } from "./plan-types.ts";

export const sharedProTitle = plans.pro.title;

export const getSharedPlanTitle = (planType: PlanType) => {
  switch (planType) {
    case "pro":
      return plans.pro.title;
    case "teacher":
      return plans.teacher.title;
    case "deck_producer":
      return "MemoCard Deck Producer";
    case "plus":
      return "MemoCard Plus";
    default:
      return planType satisfies never;
  }
};
